import { brandingImporter } from '@sbx/prec-shared-utils';

export const withContext = {
  computed: {
    context() {
      return brandingImporter();
    },
  },
};
